import { createContext } from "react";

export type NodeConnectionParams = {
  // URL containing the schema and the address of the humanode.
  url: string;
};

export const NodeConnectionParamsContext =
  createContext<NodeConnectionParams | null>(null);
